export default {
  transformer: {
    heroTag: 'Transformation Platform',
    heroTitlePre: 'GPAX Transformer:',
    heroTitleHighlight: 'Oracle Forms to WEB',
    heroDesc: 'We transform your Oracle Forms application into a next-generation WEB application and move your data to a modern database engine.',
    diagramAlt: 'GPAX transformation process',
    offerTitle: 'Our Offer',
    offerLine1: 'We transform your',
    offerBold1: 'Oracle Forms',
    offerLine2: 'application into a',
    offerBold2: 'next-generation WEB application',
    offerLine3: 'and we move your data to a',
    offerBold3: 'modern database engine',
    contact: 'Contact us',
    featuresTitle: 'Features',
    feature1Title: 'Automatic and reliable',
    feature1Desc: 'Automatically transforms PL/SQL code to TypeScript, ensuring a safe transfer of your business logic to the new technology stack.',
    feature2Title: 'Modern and adaptable',
    feature2Desc: 'Transforms forms and reports into a modern and responsive WEB interface.',
    feature3Title: 'Independent of the data layer',
    feature3Desc: 'Decouples all the logic (fmb, rpf, pll, packages and stored procedures) into microservices, removing any dependency on the data layer.',
    advantagesTitle: 'Advantages',
    advantage1Title: 'Save time and money',
    advantage1Desc: 'Transform your application in months and for 30% of the cost of developing from scratch.',
    advantage2Title: 'Paradigm shift',
    advantage2Desc: 'Using the API, it exposes the processes that are currently hidden in the Form, to achieve organic integration with the digital ecosystem.',
    advantage3Title: 'Broad support',
    advantage3Desc: 'The technology stack has a large community of developers and support for Microsoft AD, georeferencing, AI, etc.',
    ctaTitle: 'Want to know more about us?',
    contactButton: 'Contact us',
  },
};